import _cloneDeep from "lodash/cloneDeep";
import { processVehicleComment } from "../../../utilities/abg-util/vehicleCommentUtil";
import { BaseServiceRequestPayload } from "../types";

export const CUSTOMER_REFUSED_DEFLECTION_COMMENT_TYPE = "customer_refused_deflection";
export const CUSTOMER_REFUSED_DEFLECTION_COMMENT = "Customer refused deflection";

// Builds the request body for the Decline (Continue) partial save. The commentType is set to
// customer_refused_deflection so call representatives can identify this scenario, while the
// comment itself carries a human-readable message. The human-readable message is appended to
// any existing commentRequest.comment, reusing the same merge semantics as the existing
// APPEND_VEHICLE_COMMENT_REQUEST action/reducer case.
export function buildDeclinePartialSavePayload(
  serviceRequestPayload: BaseServiceRequestPayload
): BaseServiceRequestPayload {
  const clonedPayload = _cloneDeep(serviceRequestPayload);
  const existingComment = clonedPayload.commentRequest?.comment || "";
  const comment = processVehicleComment(existingComment, CUSTOMER_REFUSED_DEFLECTION_COMMENT);

  return {
    ...clonedPayload,
    commentRequest: {
      commentType: CUSTOMER_REFUSED_DEFLECTION_COMMENT_TYPE,
      comment,
    },
  };
}
